import React from "react"
import { Box } from "@singita/components"
import { hideByTag } from "gatsby-singita-theme/src/common/utils"
import CardHeroWrapper from "./CardHeroWrapper"

const LodgeConservation = ({ lodge }) => {
  const patternProps = {
    color: lodge.color,
    path: lodge.pattern?.pattern,
  }
  return (
    !!lodge.conservation && (
      <>
        {hideByTag(lodge.conservation, "SPVC").map((c, index) => {
          return (
            <Box data-testid="lodge-conservation-partner" mb={[15]} key={index}>
              <CardHeroWrapper {...c} patternProps={patternProps} />
            </Box>
          )
        })}
      </>
    )
  )
}

export default LodgeConservation
